import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { Locale } from '../types';

import en from './locales/en.json';
import th from './locales/th.json';

const resources = {
  en: { translation: en },
  th: { translation: th },
};

i18n.use(initReactI18next).init({
  resources,
  lng: (typeof window !== 'undefined' && (localStorage.getItem('appLang') as Locale)) || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
export { i18n };
